import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Main } from './Main';
import { Routes, Route } from 'react-router-dom';

import { useState, useEffect } from 'react';
import { Painel } from './painel';
import { FormProvider } from './Context';


function App() {
  const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerHeight > window.innerWidth)
      }
  
      checkMobile()
      window.addEventListener('resize', checkMobile)
      return () => window.removeEventListener('resize', checkMobile)
    }, [])

  return (
    <Routes>
      <Route path='/' element={<Main mobile={isMobile}/>}/>
      <Route path='/painel' element={<FormProvider><Painel mobile={isMobile}/></FormProvider>}/>
    </Routes>
  );
}

export default App;
